import React, { useEffect } from "react";
import { Form, Input, Button, Row, Col } from "antd";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";

import {
  submitLeadNotes,
  resetSubmitLeadNotes,
  emptyErrorObj,
  submitLeadRemarks,
} from "../../actionCreator/leadDetailsActionCreator";
import { SAVE_CLIENT_NOTE_ERROR } from "../../actionType/leadDetailsType";
import { useAlert } from "../../context/AlertProvider";
import ActivityTime from "./ActivityTime";

const { TextArea } = Input;

const Notes = ({ setActiveTab }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { showAlert } = useAlert();

  const errObj = useSelector((state) => state.LeadDetailsReducer.errObj);
  const leadDetail = useSelector(
    (state) => state.LeadDetailsReducer.leadDetails
  );
  const leadNotesSubmitted = useSelector(
    (state) => state.LeadDetailsReducer.saveleadNotes
  );
  const leadNoteDetails = useSelector(
    (state) => state.LeadDetailsReducer.leadNoteDetails
  );

  useEffect(() => {
    if (!!Object.keys(errObj).length) {
      showAlert("error", errObj[SAVE_CLIENT_NOTE_ERROR]?.message);
      dispatch(resetSubmitLeadNotes());
      dispatch(emptyErrorObj());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errObj]);

  useEffect(() => {
    if (Object.keys(leadNotesSubmitted).length) {
      showAlert(
        "success",
        leadNoteDetails?.id
          ? "Note has been updated!"
          : "Note has been submitted!"
      );
      dispatch(resetSubmitLeadNotes());
      dispatch(emptyErrorObj());
      form.resetFields();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [leadNotesSubmitted]);
  useEffect(() => {
    if (!Object.keys(leadNoteDetails).length) return;
    form.setFieldsValue({
      note: leadNoteDetails?.note,
    });
  }, [leadNoteDetails, form]);

  const redirectToTimline = () => {
    setActiveTab("1");
    form.resetFields();
  };

  const saveNotes = (values) => {
    const payload = {
      note: values.note,
      notefor: values.noteFor,
      isActive: values.isActive,
      isTask: values.isTask,
      lead: { id: leadDetail?.id },
      update: !!Object.keys(leadNoteDetails).length,
      id: leadNoteDetails?.id || "",
    };

    dispatch(submitLeadNotes(payload));

    if (!payload.update && payload.isTask) {
      const formattedDate =
        moment(new Date()).format("YYYY-MM-DDTHH:mm:ss") + "Z";
      const remarksPayload = {
        remarks: values.noteFor,
        interactionDate: formattedDate,
        isContactBackRequired: false,
        isContacted: false,
        isToDisplay: true,
        status: "open",
        title: values.note,
        lead: leadDetail,
        update: false,
        id: "",
      };
      dispatch(submitLeadRemarks(remarksPayload));
    }

    form.resetFields();
  };

  return (
    <>
      <div className="p-20">
        <h3 className="heading24px fw-semibold text-color-1C1C1C">
          Add/Edit Note
        </h3>
        <div className="errorformcontainer mt30">
          <Form form={form} layout="vertical" onFinish={saveNotes}>
            <Row className="justify-content-between">
              <Col span={24}>
                <Form.Item
                  name="note"
                  className="mb15"
                  rules={[
                    { required: true, message: "Please enter a note" },
                    { min: 10, message: "Note must be at least 10 characters" },
                    { max: 500, message: "Note can’t exceed 500 characters." },
                  ]}
                >
                  <TextArea rows={5} maxLength={500} className="bg-note" />
                </Form.Item>
              </Col>
            </Row>

            <div className="d-flex gap-20 align-items-center justify-content-end">
              <Button className="secondary-btn" onClick={redirectToTimline}>
                Cancel
              </Button>
              <Button type="primary" htmlType="submit" className="theme-btn">
                {leadNoteDetails?.id ? "Update" : "Save"}
              </Button>
            </div>
          </Form>
        </div>
        <ActivityTime setActiveTab={setActiveTab} />
      </div>
    </>
  );
};

export default Notes;
